// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2iga_","subheader":"ReorderModal_subheader__1TcP9","listWrap":"ReorderModal_listWrap__1767l"};